module.exports = __webpack_public_path__ + "img/cpnu.e1efce5c.png";